import React, { useState, useEffect } from 'react'
import cn from 'classnames'

import styles from './Employee.module.css'
import type { OrderProps, ItemProps, DroneProps, CustomerProps } from '../assets/types'
import droneImg from '../assets/drone.png'

import Geocode from 'react-geocode';
import { Link } from 'react-router-dom'

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey('AIzaSyBWcfuO7qKfWM6f4V1AtFKoMmwL7KttqBc');

// set response language. Defaults to english.
Geocode.setLanguage('en');

function getAddress(addr: string, setCoord: any): void {
  // Get latitude & longitude from address.
  Geocode.fromAddress(addr).then(
    (response: any) => {
      const c = response.results[0].geometry.location;
      setCoord(c);
    },
    (error: any) => {
      console.error(error);
    }
  );
}

function Employee(): JSX.Element {
  const [orderNum, setOrderNum] = useState(0)
  const [orders, setOrders] = useState<OrderProps[]>([])
  const [drone, setDrone] = useState<DroneProps>()
  const [customer, setCustomer] = useState<CustomerProps>()
  const [coord, setCoord] = useState<{ lat: number, lng: number }>()

  const fetchCustomer = async (id: string): Promise<void> => {
    console.log(id)
    const response = await fetch(`https://soarin-donuts-backend.fly.dev/api/customer/${id}`);
    const data = await response.json();

    if (response.status === 404) {
      throw new Error('Status 404 received');
    }
    getAddress(data.address, setCoord)
    console.log('customer', data);
    setCustomer(data);
  };

  const fetchDrone = async (id: string): Promise<void> => {
    console.log(id)
    const response = await fetch(`https://soarin-donuts-backend.fly.dev/api/drone/${id}`);
    const data = await response.json();

    if (response.status === 404) {
      throw new Error('Status 404 received');
    }
    console.log('drone', data);
    setDrone(data);
  };

  const sendDrone = async (order: string, id: string, lat: number | undefined, lon: number | undefined): Promise<number> => {
    const requestOptions = {
      method: 'PUT'
    };
    const response = await fetch('https://soarin-donuts-backend.fly.dev/api/drones/' + id.toString() + '/' + (lat ?? 90).toString() + '/' + (lat ?? 90).toString() + '/send', requestOptions);
    const response2 = await fetch('https://soarin-donuts-backend.fly.dev/api/start-order/' + order);
    // const data = await response.json();
    if (response.status === 404) {
      throw new Error('Status 404 received');
    }
    console.log('data: ', response);
    return response.status;
  };

  const fetchOrders = async (): Promise<void> => {
    const response = await fetch('https://soarin-donuts-backend.fly.dev/api/orders');
    const data = await response.json();

    if (response.status === 404) {
      throw new Error('Status 404 received');
    }
    void fetchDrone(data[orderNum].drone)
    void fetchCustomer(data[orderNum].customer)
    console.log(coord)
    console.log('data', data);
    setOrders(data);
  };

  const curOrder: OrderProps = orders[orderNum]
  const statusText = (): string =>
    curOrder?.deliveryStatus !== 'pending' ? 'Completed' : 'Mark Complete'
  const [btn, setBtn] = useState(statusText())

  useEffect(() => {
    setBtn(statusText())
    void fetchOrders();
  }, [orderNum])

  return (
    <div className={styles.container}>
      <div className={styles.orders}>
        <h1 className="text-3xl mb-2 font-bold">Order Queue</h1>
        <ul role="list">
          {orders.map((order, index) => (
            <Order
              {...order}
              index={index}
              orderNum={orderNum}
              setOrderNum={setOrderNum}
            />
          ))}
        </ul>
      </div>
      <div className={styles.selectedOrder}>
        <h1 className="text-3xl mb-6 font-bold">Order</h1>
        <ul role="list" className="mb-8">
          {curOrder?.items?.map((item) => {
            return <Item {...item} />
          })}
        </ul>
        {drone?.drone_name != null && <div className="mb-6">
          <h1 className="text-3xl mb-6 font-bold">Assigned Drone</h1>
          <div className={styles.drone}>
            <img className="h-14 mr-4" src={droneImg} alt="drone icon" />
            <div className={styles.droneInfo}>
              <p className="text-lg font-bold">{drone?.drone_name}</p>
              <p className="text-md text-slate-500">
                Battery:{' '}
                {((drone?.battery?.charge ?? 0) /
                  (drone?.battery?.capacity ?? 1)) *
                  100}
                %
              </p>
            </div>
          </div>
        </div>}
        <div className={styles.navigation}>
          <Link
            className="bg-white hover:bg-gray-100 disabled:bg-gray-200 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
            to={{ pathname: '/stock' }}
          >
            Adjust Stock
          </Link>
          <button
            disabled={orderNum === 0}
            onClick={() => {
              if (orderNum === 0) return
              setOrderNum(orderNum - 1)
            }}
            className="bg-white hover:bg-gray-100 disabled:bg-gray-200 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
          >
            Previous
          </button>
          <button
            onClick={() => {
              void sendDrone(curOrder._id, curOrder.drone, coord?.lat, coord?.lng)
              setBtn('Complete')
            }}
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          >
            {btn}
          </button>
          <button
            disabled={orderNum === orders.length - 1}
            onClick={() => {
              if (orderNum === orders.length - 1) return
              setOrderNum(orderNum + 1)
            }}
            className="bg-white hover:bg-gray-100 disabled:bg-gray-200 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  )
}

function Item({ donut, quantity }: ItemProps): JSX.Element {
  return (
    <li className={cn('flex py-4 first:pt-0 last:pb-0', styles.orderItem)}>
      <div className={styles.itemInfo}>
        <img className="h-14 w-14" src={`images/${donut.picture}.jpg`} alt={donut.name} />
        <div className="ml-3 overflow-hidden">
          <p className="text-md font-medium text-slate-900">{donut.name}</p>
          <p className="text-md text-slate-500 truncate">{donut.price}</p>
        </div>
      </div>
      <div
        className={cn(
          'font-semibold text-blue-700 bg-blue-100',
          styles.quantity
        )}
      >
        Quanitity: {quantity}
      </div>
    </li>
  )
}

function Order({
  id,
  index,
  deliveryStatus,
  _id,
  orderNum,
  setOrderNum
}: OrderProps): JSX.Element {
  return (
    <li
      key={id}
      className={cn(
        'group/item hover:bg-slate-100 my-1',
        styles.order,
        deliveryStatus === 'Complete' && 'bg-green-100',
        index === orderNum
          ? 'bg-slate-200 border-2 border-slate-600'
          : 'border-2 border-transparent'
      )}
      onClick={() => {
        setOrderNum(index)
      }}
    >
      <div>
        <p
          className={
            deliveryStatus === 'Complete'
              ? 'text-green-900 font-bold'
              : 'text-default'
          }
        >
          Order {_id}
        </p>
      </div>
    </li>
  )
}

export default Employee
